/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationCampaigns.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CertificationCampaignsTestIds = {
  btnCreateCampaign: "btn-create-campaign",
  btnGenerateCampaigns: "btn-generate-campaigns",
  campaignComboboxPolicy: "campaign-combobox-policy",
  certificationCampaignsList: "certification-campaigns-list",
  colDueDate: "col-due-date",
  colName: "col-name",
  colOwner: "col-owner",
  colPolicy: "col-policy",
  colStatus: "col-status",
  campaignName: (campaign_id: string) => `campaign-name-${campaign_id}`,
  campaignNamePrefix: () => "campaign-name-" as TestIdPrefix,
  campaignOwner: (campaign_id: string) => `campaign-owner-${campaign_id}`,
  campaignOwnerPrefix: () => "campaign-owner-" as TestIdPrefix,
  campaignPolicy: (campaign_id: string) => `campaign-policy-${campaign_id}`,
  campaignPolicyPrefix: () => "campaign-policy-" as TestIdPrefix,
  campaignPolicyLink: (campaign_id: string) => `campaign-policy-link-${campaign_id}`,
  campaignPolicyLinkPrefix: () => "campaign-policy-link-" as TestIdPrefix,
  campaignStatus: (campaign_id: string) => `campaign-status-${campaign_id}`,
  campaignStatusPrefix: () => "campaign-status-" as TestIdPrefix,
  linkCampaign: (campaign_id: string) => `link-campaign-${campaign_id}`,
  linkCampaignPrefix: () => "link-campaign-" as TestIdPrefix
} as const;
